const TERMINAL_STATUSES: CalculationDocumentExtractionStatus[] = [
  'completed',
  'partial',
  'failed',
]

const sleep = (ms: number) => new Promise((resolve) => {
  setTimeout(resolve, ms)
})

type FetchDocument = (args: { orderId: string; documentId: number }) => Promise<CalculationDocument>

export const pollOrderDocumentUntilReady = async (
  fetchDocument: FetchDocument,
  orderId: string,
  documentId: number,
  maxAttempts = 90,
): Promise<CalculationDocument> => {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const document = await fetchDocument({ orderId, documentId })
    if (TERMINAL_STATUSES.includes(document.extraction_status)) {
      return document
    }
    await sleep(2000)
  }
  throw new Error('document_import_timeout')
}
